import { Box } from "@mui/material";
import { careersContent } from "../data/careersContent";
import WhatMakesHungerfordDifferent from "../components/common/WhatMakesHungerfordDifferent";
import EngineerTestimonials from "../components/common/EngineerTestimonials";
import CareerPathTimeline from "../components/common/CareerPathTimeline";
import WhyWorkAtHungerford from "../components/common/WhyWorkAtHungerford";
import NewReadyToApply from "../components/common/NewReadyToApply";
import HeroParallaxSection from "../components/sections/HeroParallaxSection";

const CarrersPage: React.FC = () => {
  const {
    sectionLabel,
    title,
    subtitle,
    workAtHungerford,
    whatMakesHungerfordDifferent,
  } = careersContent;

  return (
    <>
      {/* Hero Section Label */}
      <HeroParallaxSection
        sectionLabel={sectionLabel}
        title={title}
        subtitle={subtitle}
      />

      <Box sx={{ maxWidth: "1050px", mx: "auto", px: { xs: 3, md: 3, lg: 0 } }}>
        {/* Why work at Hungerford text */}
        <WhyWorkAtHungerford
          heading={workAtHungerford.heading}
          content={workAtHungerford.content}
          imageSrc="/assets/team2.jpg"
          alignTextVertical="top"
        />

        {/* Path timeline */}
        <CareerPathTimeline />

        {/* What makes Hungerford different */}
        <WhatMakesHungerfordDifferent
          heading={whatMakesHungerfordDifferent.heading}
          features={whatMakesHungerfordDifferent.features}
        />
      </Box>

      {/* Testimonials */}
      <EngineerTestimonials />

      <Box
        sx={{
          maxWidth: "1050px",
          mx: "auto",
          px: { xs: 3, md: 3, lg: 0 },
        }}
      >
        <NewReadyToApply />
      </Box>
    </>
  );
};

export default CarrersPage;
